import {_utils} from "./_utils.js";
import Swiper from "swiper";
import {Keyboard, Autoplay, EffectFade, Controller, FreeMode, Navigation, Pagination} from "swiper/modules";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {_state} from "../state/state.js";
import 'lazysizes';

import TomSelect from "tom-select";
import Lenis from 'lenis';
import Lottie from 'lottie-web';


Swiper.use([Keyboard,Navigation,Pagination,Autoplay,EffectFade,Controller,FreeMode]);
gsap.registerPlugin(ScrollTrigger);
gsap.ticker.fps(60);


export const _libs = {
    init() {
        return new Promise(async (resolve, reject) => {
            await Promise.all([
                this._initCustomSelect(),
                this._lenis(),
                this._lottie(),
            ]);
            resolve();
        });
    },
    initOnUserInteraction() {
        return new Promise(async (resolve, reject) => {
            await Promise.all([

            ]);
            resolve();
        });
    },

    _lazyLoad() {
        return new Promise((resolve) => {
            const prepareLazyLoad = (elements, srcAttr = 'src', srcSetAttr = 'srcset') => {
                elements.forEach((el) => {
                    el.setAttribute('data-expand', `${window.innerHeight * 0.5}`);
                });
            };
            const images = document.querySelectorAll('img[data-src], img[data-srcset]');
            prepareLazyLoad(images);

            const videos = document.querySelectorAll('video');
            videos.forEach((video) => {
                if(video.hasAttribute('data-src')){
                    let once = true;
                    const src = video.getAttribute('data-src');
                    video.addEventListener('play', () => {
                        if(once){
                            once = false;
                            video.setAttribute('src', src);
                            video.removeAttribute('data-src');
                        }
                    })
                }
            });

            resolve();
        })
    },

    _initCustomSelect() {
        return new Promise((resolve) => {
            const selects = document.querySelectorAll('select:not(.js-handled)');
            if (selects.length > 0) {
                selects.forEach(select => {
                    select.classList.add('js-handled');
                    _libs._tomSelect(select);
                })
            }

            resolve();
        })
    },

    _tomSelect(select) {
        return new TomSelect(select, {
            create: false, // Allows you to enter your own values
            //sortField: { field: "text", direction: "asc" }, // Sorting
            maxItems: 1, // Number of selected items
            hideSelected: false, // Hide selected
            allowEmptyOption: true, // Prohibit empty value

            controlInput: false,

            closeAfterSelect: true, // Close the list after selecting an item
            selectOnTab: true, // Select an item by pressing Tab
        });
    },
    _lenis() {
        return new Promise((resolve, reject) => {
            if (!_utils.isMobile.any()) {
                const lenis = new Lenis({
                    duration: 1.5,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                    smooth: true,
                });

                function raf(time) {
                    lenis.raf(time);
                    requestAnimationFrame(raf);
                }

                requestAnimationFrame(raf);
                _state.updateState({lenisInit: lenis});
            }
            resolve();
        });
    },

    _createAnim(params) {
        return Lottie.loadAnimation(params);
    },
    _lottieCreate(block, closest) {
        let lottieAnimation = null;

        const animPath = block.hasAttribute('data-anim-path') && block.getAttribute('data-anim-path').length > 0
            ? block.getAttribute('data-anim-path') : null;
        const animSpeed = block.hasAttribute('data-anim-speed') && block.getAttribute('data-anim-speed').length > 0
            ? block.getAttribute('data-anim-speed') : null;
        const animLoop = block.hasAttribute('data-anim-loop');
        const animLoopReverse = block.hasAttribute('data-anim-loop-reverse');
        const imagesPreview = block.querySelectorAll('img');


        const animParams = {
            container: block,
            renderer: 'canvas', //svg/canvas/html
            loop: animLoop,
            autoplay: closest && closest.classList.contains('s-visible'),
        }
        if (animPath) {
            animParams.path = animPath;
        }

        if ('path' in animParams) {
            try {
                lottieAnimation = _libs._createAnim(animParams);
                if (animSpeed) {
                    lottieAnimation.setSpeed(animSpeed);
                }
                lottieAnimation.addEventListener('DOMLoaded', function () {
                    imagesPreview.forEach(img => {
                        if (img) {
                            img?.remove();
                        }
                    });
                });

            } catch (error) {
            }
        }

        if (lottieAnimation && animLoopReverse) {
            let direction = 1;

            lottieAnimation.addEventListener('complete', function () {
                direction *= -1;
                lottieAnimation.setDirection(direction);
                lottieAnimation.play();
            });
        }
        if (lottieAnimation && closest) {
            closest.addEventListener('sVisible', () => {
                lottieAnimation.play();
            })
            closest.addEventListener('sHidden', () => {
                lottieAnimation.pause();
            })
        }
    },
    _lottie() {
        return new Promise((resolve, reject) => {
            const blocks = document.querySelectorAll('.lottie');
            if (blocks.length > 0) {
                blocks.forEach(block => {
                    const closest = block.closest('[data-section]');
                    const dataTimeout = block.hasAttribute('data-timeout') && block.getAttribute('data-timeout').length > 0
                        ? block.getAttribute('data-timeout') : null;
                    if (closest) {
                        let initOnce = false;
                        closest.addEventListener('sVisible', () => {
                            if (!initOnce) {
                                initOnce = true;
                                console.log(dataTimeout)
                                if (dataTimeout) {
                                    setTimeout(()=> {
                                        console.log('yes timeout')
                                        _libs._lottieCreate(block, closest);
                                    },dataTimeout)
                                } else {
                                    console.log('no timeout')
                                    _libs._lottieCreate(block, closest);
                                }
                            }
                        })
                    }
                })
            }
            resolve();
        })
    },

    _swiper(container, options) {
        const swiper = new Swiper(container, options);

        _utils.rebuildComponentsOnResize(() => {
            if (swiper) swiper.update();
        });

        return swiper;
    },
    _gsap(options = {}) {
        const tl = gsap.timeline({
            scrollTrigger: options,
        });

        _utils.rebuildComponentsOnResize(() => {
            if (tl && tl.scrollTrigger) tl.scrollTrigger.refresh();
        });
        return tl;
    },
}